import Logo from '../Images/Logo.svg';
import Search from '../Images/search.svg';
import HomeBanner from '../Images/Banners/home-banner.png';
import CardOne from '../Images/CardImages/CardOne.png';
import CardTwo from '../Images/CardImages/CardTwo.png';
import CardThree from '../Images/CardImages/CardThree.png';
import CallIcon from '../Images/phone.svg';
import MailIcon from '../Images/mail.svg';
import LocationIcon from '../Images/location.svg';
import rightSpeciality from '../Images/Speciality/Right.png';
import leftSpeciality from '../Images/Speciality/Left.png';
import LogoOne from '../Images/ClientLogo/logoOne.png';
import LogoTwo from '../Images/ClientLogo/logoTwo.png';
import LogoThree from '../Images/ClientLogo/LogoThree.png';
import LogoFour from '../Images/ClientLogo/logoFour.png';
import LogoFive from '../Images/ClientLogo/logoFive.png';
import LogoSix from '../Images/ClientLogo/logoSix.png';
import LogoSeven from '../Images/ClientLogo/logoSeven.png';
import LogoEight from '../Images/ClientLogo/logoEight.png';
import LogoNine from '../Images/ClientLogo/logoNine.png';
import TreeIcon from '../Images/tree-setup.svg';
import ClientOne from '../Images/StrategicClient/clientOne.png';
import ClientTwo from '../Images/StrategicClient/clientTwo.png';
import ClientThree from '../Images/StrategicClient/ClientThree.png';
import ClientFour from '../Images/StrategicClient/ClientFour.png';
import ClientFive from '../Images/StrategicClient/ClientFive.png';
import ClientSix from '../Images/StrategicClient/ClientSix.png';
import AboutBanner from '../Images/Banners/about-banner.png';
import Vision from '../Images/vision.png';
import DropdownIcon from '../Images/Dropdown.svg';
import MinusIcon from '../Images/Minus.svg';
import LeaderLogo from '../Images/leader-logo.png';
import MemberOne from '../Images/Team/MemberOne.png';
import MemberTwo from '../Images/Team/MemberTwo.png';
import MemberThree from '../Images/Team/MemberThree.png';
import MemberFour from '../Images/Team/MemberFour.png';
import MemberFive from '../Images/Team/MemberFive.png';
import MemberSix from '../Images/Team/MemberSix.png';
import MemberSeven from '../Images/Team/MemberSeven.png';
import MemberEight from '../Images/Team/MemberEight.png';
import MemberNine from '../Images/Team/MemberNine.png';
import MemberTen from '../Images/Team/MemberTen.png';
import MemberIcon from '../Images/Team/MemberICon.png';
import LinkedInIcon from '../Images/Team/linkedin.svg';
import BlackDots from '../Images/Team/BlackDots.svg';
import WhiteDots from '../Images/Team/WhiteDots.svg';
import ComminSoonImage from '../Images/coming-soon.jpg';

import WorkDriyah from '../Images/OurWork/diriyahw1.png'
import WorkFerrari from '../Images/OurWork/Ferrariw1.png'
import WorkRed from '../Images/OurWork/Redw1.png'
import WorkTad from '../Images/OurWork/Tadawulw2.png'





const Assets = {
    Logo,
    Search,
    HomeBanner,
    CardOne,
    CardTwo,
    CardThree,
    CallIcon,
    MailIcon,
    LocationIcon,
    rightSpeciality,
    leftSpeciality,
    LogoOne,
    LogoTwo,
    LogoThree,
    LogoFour,
    LogoFive,
    LogoSix,
    LogoSeven,
    LogoEight,
    LogoNine,
    TreeIcon,
    ClientOne,
    ClientTwo,
    ClientThree,
    ClientFour,
    ClientFive,
    ClientSix,
    AboutBanner,
    Vision,
    DropdownIcon,
    MinusIcon,
    LeaderLogo,
    MemberOne,
    MemberTwo,
    MemberThree,
    MemberFour,
    MemberFive,
    MemberSix,
    MemberSeven,
    MemberEight,
    MemberNine,
    MemberTen,
    MemberIcon,
    LinkedInIcon,
    BlackDots,
    WhiteDots,
    ComminSoonImage,

    WorkDriyah,
    WorkFerrari,
    WorkRed,
    WorkTad

}

export default Assets;